import React from "react";
import { useNavigate } from "react-router";
import { COMPONENT_UNKNOWN_YEAR, REPORT_PAGES_ROUTES, } from "../../../constants";
import { filterByLink } from "../../../store/issuesSlice";
import { ComponentAgeTimeline } from "../../../ui";
import { LinkToReportTab } from "../../common";
import { useReportDispatch } from "../../hooks";
const ComponentAgeTimelineContainer = ({ timeline, }) => {
    const dispatch = useReportDispatch();
    const navigate = useNavigate();
    return (React.createElement(ComponentAgeTimeline, { timeline: timeline, helperText: React.createElement(LinkToReportTab, { id: "All components", to: REPORT_PAGES_ROUTES.FILE_BROWSER_ROUTE, color: "link" }, "All components"), onBarClick: (year, isUnknownYear) => {
            const filterYear = isUnknownYear ? COMPONENT_UNKNOWN_YEAR : year;
            dispatch(filterByLink({
                component_age: {
                    operation: "is",
                    values: [filterYear],
                },
            }));
            navigate(REPORT_PAGES_ROUTES.ISSUES_ROUTE);
        } }));
};
export default ComponentAgeTimelineContainer;
//# sourceMappingURL=ComponentAgeTimeline.js.map